<router-outlet></router-outlet>
<ngx-ui-loader></ngx-ui-loader>
<app-modal *ngIf="modalService.isModalVisible"></app-modal>
